import React from "react";
// COMPONENTS
import SiteButton from "Components/WebsiteTheme/SiteButton";
import SiteSectionHead from "Components/WebsiteTheme/SiteSectionHead";
import { IconChevron, ToneIcon } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { STEPS } from "Components/WebsiteTheme/site.data";
import { TONES } from "Components/WebsiteTheme/WebsiteTheme.style";
// STYLES
import { HowItWorksSection } from "./LandingPage.style";

/** Create, Engage, Track, Reuse: the four steps, with the site's one "Watch the 1-Minute Video" button. */
const HowItWorks = ({ onWatchVideo }) => (
	<HowItWorksSection id="how-it-works" className="sm_section">
		<div className="sm_container">
			<SiteSectionHead {...revealProps("up")} align="center" title="How Subjects Master Works" lead="Your content becomes interactive gaming study guides in just a few steps." />

			<ol className="hw_grid">
				{STEPS.map((step, index) => (
					<li key={step.key} className="hw_item" {...revealProps("up", index)}>
						<article className={`hw_card sm_tone--${step.tone}`}>
							<span className="hw_num" style={{ backgroundColor: TONES[step.tone].ink }} aria-hidden="true">
								{index + 1}
							</span>
							<ToneIcon iconKey={step.key} tone={step.tone} />
							<div className="hw_copy">
								<h3 className="sm_h4">{step.title}</h3>
								<p className="sm_small">{step.text}</p>
							</div>
						</article>
						{index < STEPS.length - 1 && <IconChevron className="hw_next" />}
					</li>
				))}
			</ol>

			<div className="hw_action">
				<SiteButton icon="play" className="hw_video_btn" onClick={onWatchVideo}>
					Watch the 1-Minute Video
				</SiteButton>
			</div>
		</div>
	</HowItWorksSection>
);

export default HowItWorks;
